module.exports = __webpack_public_path__ + "static/Makkabi-Regular-f506d07c37ee52ad8c8f1ee637ef7a1a.woff";